<div class="cpcontent googlesignin" [hidden]="isAuthenticatedWithFirebase">
  <h5>Signin with Google to access the Firebase database</h5>
  <br>
  <div class="row">
    <div class="col-md-6">
      <button class="btn btn-primary" (click)="signInWithGoogle()">Sign in with Google</button>
    </div>
  </div>
</div>

<div class="cpcontent" [hidden]="!isAuthenticatedWithFirebase">
  <h1 style="display:inline-block"> Firebase Maintenance</h1>
  <button class="btn btn-primary btn-sm" 
          (click)="getData()" 
          [disabled]="loading" 
          style="float:right;margin-top:10px">
    <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
    <i class="bi bi-arrow-clockwise me-1"></i>Refresh
  </button>
  <br>
  <br>
  <div class="mb-2" *ngIf="nodeSizes.length > 0">
    <strong>Total Size:</strong>
    {{ totalSizeBytes | number:'1.0-0' }} bytes
  </div>
  <h3>Be carful of what you are doing!</h3>
  Keep the size of the database small by cleaning up old data: <br>
  
  <!-- <div class="alert alert-warning" style="margin-top:15px; margin-bottom:15px;">
    <h5><i class="bi bi-exclamation-triangle-fill me-2"></i>Database Cleanup Operations</h5>
    <p class="mb-2">The following operations will be performed to reduce database size:</p>
    <ul class="mb-0">
      <li><strong>Remove all renderlogs</strong> - Clears rendering performance data</li>
      <li><strong>Remove all events</strong> - Clears event tracking data</li>
      <li><strong>Remove all performance logs</strong> - Clears performance monitoring data</li>
      <li><strong>Remove old exercises</strong> - Removes exercises older than 2 days</li>
    </ul>
  </div> -->
  
  <!-- <button class="btn btn-danger" 
          (click)="reduceAll()" 
          [disabled]="loading" 
          style="margin-top:10px">
    <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
    <i class="bi bi-database-dash me-1"></i>Reduce Database Size
  </button><br> -->


  <!-- Confirm Delete Modal with backdrop -->
  <div class="modal" tabindex="-1" [ngClass]="{show: showConfirmModal}" [ngStyle]="{ display: showConfirmModal ? 'block' : 'none' }" aria-modal="true" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-danger text-white">
          <h5 class="modal-title"><i class="bi bi-exclamation-triangle-fill me-2"></i>Confirm Delete</h5>
          <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="cancelDelete()"></button>
        </div>
        <div class="modal-body">
          Are you sure you want to delete <strong>ALL {{ pendingDeleteNode }}</strong>? This cannot be undone.
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" (click)="cancelDelete()">Cancel</button>
          <button class="btn btn-danger" (click)="confirmDelete()">
            <i class="bi bi-trash me-1"></i>Delete All {{ pendingDeleteNode }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Backdrop -->
  <div class="modal-backdrop fade" [ngClass]="{show: showConfirmModal}" *ngIf="showConfirmModal"></div>

  <!-- Schema Modal with backdrop -->
  <div class="modal" tabindex="-1" [ngClass]="{show: showSchemaModal}" [ngStyle]="{ display: showSchemaModal ? 'block' : 'none' }" aria-modal="true" role="dialog">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">ModalHandler schema (defaults)</h5>
          <button type="button" class="btn-close" aria-label="Close" (click)="closeSchemaModal()"></button>
        </div>
        <div class="modal-body">
          <pre style="white-space: pre-wrap; margin:0;">{{ modalHandlerSchemaText }}</pre>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" (click)="closeSchemaModal()">Close</button>
          <button class="btn btn-primary" (click)="copySchemaToClipboard()">Copy</button>
        </div>
      </div>
    </div>
  </div>
  <!-- Backdrop -->
  <div class="modal-backdrop fade" [ngClass]="{show: showSchemaModal}" *ngIf="showSchemaModal"></div>
  <table class="table table-striped table-bordered table-sm" *ngIf="nodeSizes.length > 0">
    <thead class="thead-dark">
      <tr>
        <th scope="col" class="sortable" (click)="sortBy('node')">Node <span>{{tableSortCol==='node' ? (tableSortDir==='asc' ? '▲' : '▼') : '↕'}}</span></th>
        <th scope="col" class="text-end pe-4 sortable" (click)="sortBy('sizeBytes')">Size (Bytes) <span>{{tableSortCol==='sizeBytes' ? (tableSortDir==='asc' ? '▲' : '▼') : '↕'}}</span></th>
        <th class="text-end pe-4 sortable" (click)="sortBy('numChildren')">Number of Nodes <span>{{tableSortCol==='numChildren' ? (tableSortDir==='asc' ? '▲' : '▼') : '↕'}}</span></th>
        <th>Maintenance</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of sortedNodeSizes">
        <td>{{ item.node }}</td>
        <td class="text-end pe-4">{{ item.sizeBytes >= 0 ? (item.sizeBytes | number:'1.0-0') : 'Error' }}</td>
        <td class="text-end pe-4">
          {{ item.numChildren !== undefined ? (item.numChildren | number:'1.0-0') : 'N/A' }}
        </td>
        <td>
          <button *ngIf="item.node === 'events' || item.node === 'exercises'"
                  class="btn btn-danger btn-sm"
                  (click)="deleteNode(item.node)">
            Delete
          </button>
          <a *ngIf="item.node === 'performance'" [routerLink]="['/performance']">Maintain Performance here</a>
        </td>
      </tr>
    </tbody>
  </table>
</div>